window.dn = window.dn || {};

/** 
 * This will store properties for the currently logged-in user, which gets set in 
 * _LayoutScriptsPartial.cshtml, as well as user-related JS methods. 
 * 
 * NOTE: User autosuggestions are available via dn.autosuggest.js.
 */
(function (user, $, undefined)
{
    user.AvatarIcons = 
    { 
        // Other things can be here if we want/need be. I also assume this will get moved.
        Mute : {
            Content: "<div class=\"dn-icon-mute\" title=\"User Muted\"></div>",
            Selector: ".dn-icon-mute"
        },
        Deactivated : { 
            Content: "<div class=\"dn-icon-deactivated\" title=\"User Deactivated\"><span>x</span></div>",
            Selector: ".dn-icon-deactivated"
        },
        Staff : {
            Content: "<img class=\"dn-icon-staff\" title=\"DN Staff Member\" src=\"https://d3tl0hgcgcslkv.cloudfront.net/img/dnlogo-32w.png\" >",
            Selector: ".dn-icon-staff"
        },
    };

    /**
     * Append the desired icon profile to the target avatar. This restructures 
     * the html and adds a container for these icons. 
     * 
     * @param {selector}      targetSelector target to the image to overlay the icon over
     * @param {dn.user.AvatarIcons}      avatarIcon target to the image to overlay the icon over
     * @param {bool}      isChat whether or not to use the smaller profile/sizing for the chat page or the larger for the profile page
     */
    user.AppendAvatarIcon = function(targetSelector, avatarIcon, isChat)
    {
        let pageIndicator = isChat ? "chat" : "profile"

        if (avatarIcon != undefined)
        {
            var newIcon =  
                '<div class=\"dn-' + pageIndicator + '-icon\">' +                      
                    avatarIcon.Content +
                '</div>'

            var container = $(targetSelector).siblings(".dn-" + pageIndicator + "-icon-container");

            // Ensure the icon doesn't already exist
            if (!$(container).find(avatarIcon.Selector).length)
            {
                // If the container already exists just add the new icon, otherwise construct the wrapper and container
                if ( $(container).length) 
                {
                    $(container).append(newIcon);
                } 
                else 
                {
                    // Grab the target image, and wrap it in a container then add the icon container, adding the icon 
                    var currentElementHtml = $(targetSelector).prop('outerHTML');
                    var wrapped = '<div class=\"dn-icon-wrapper\">' + 
                                        currentElementHtml +
                                        '<div class=\"dn-' + pageIndicator + '-icon-container\">' + 
                                            newIcon +                                    
                                        '</div>\
                                    </div>'
                    $(targetSelector).replaceWith(wrapped)
                }
            }

        } 
    }

    /**
     * Given a list of required badge ids, this returns a list of any missing badges,
     * based on the badges held by the currently logged-in user.
     * 
     * @param {Array<number>} topicIds - List of topic IDs.
     * @returns {Array<number>} - Set of missing badge IDs.
     */
    user.GetMissingBadges = function(requiredBadges) 
    {
        if (dn.user.IsLoggedIn) 
        {   
            // Filter out the required badges that the user does not have, and return them
            return requiredBadges.filter
            (
                function(badgeId) 
                {
                    return !dn.user.BadgeIds.has(badgeId); 
                }
            );
        } 
        else 
        {
            // If the user is not logged in, consider all required badges as missing
            return requiredBadges;
        }
    };

    /**
     * Returns true if the user has been awarded all of given badges.
     * 
     * @param {Array<number>} requiredBadges - A list of BadgeIds of required badges that the user must hold.
     * @returns {boolean} True if the current user has all of the required badges.
     */
    user.HasRequiredBadges = function(requiredBadges)
    {
        return user.GetMissingBadges(requiredBadges).length === 0;
    };

    /**
     * Internal function called when something has changed on the "Invite" form and
     * we want to see whether or not we should enable the Invite button, among other things.
     */
    var checkEnableInviteButton = dn.Debounce
    (
        function()
        {
            var invitees = $('#dn-user-search-invite').val();

            // Enable the Invite button if there is at least one invitee...
            // and they're not a group manager, or they are and it contains at
            // least one email address (non-member invite), or they have included groups.
            if (invitees && (!dn.user.IsGroupManager || invitees.indexOf("@") > -1 || $('#dn-group-search').val()))
            {
                $(".dn-group-invite-button").prop("disabled", false);
            }
            else
            {
                $(".dn-group-invite-button").prop("disabled", true);
            }
        },
        100,    // wait 100ms
        false   // execute after the first time period passes
    );

    /**
     * Invite a user to join our community and/or one or more groups, or approve a subscription request, with an optional message.
     * 
     * @param {array}   opt.groups          - A list of TopicIds or TopicKeys of groups to invite the user(s) to. If not given, we'll present a popup to prompt them to choose.
     * @param {array}   opt.initialGroups   - An array of initial group options so that we can show any pre-selected groups.
     * @param {array}   opt.prefilledUsers  - A list of UserKeys and/or email addresses of users to invite/approve that will be preset in the form.
     * @param {array}   opt.suggestedUsers  - An array of initial user suggestions, if the user clicks into the user field, they can choose from these without typing.
     * @param {string}  opt.message         - If set, will be sent to the user being invited/approved.
     * @param {func}    opt.onSuccess       - If we're able to successfully invite (or queue invitation), we'll call this with the response.
     * @param {func}    opt.onError         - If we can't invite/approve the user for some reason, we'll call this with the jquery error info
     */
    user.Invite = function(opt) 
    {
        if (!opt)
        {
            opt = {};
        }

        // We'll save this result as a top level `dn.user` property so we can refer to it in `checkEnableInviteButton`
        dn.user.IsGroupManager = (dn.user.IsLoggedIn && dn.user.UserGroupsManaged.length > 0);

        var intro = 'Invite colleagues to join ' + dn.constants.CommunityName + ' by supplying their email addresses.';
        var userAria = 'Email addresses of people to invite';
        var userPlaceholder = 'Email addresses';
        var award = '';

        if (dn.user.IsGroupManager)
        {
            // If we are showing the groups field, they can lookup existing users as well.
            intro = 'Invite colleagues to join ' + dn.constants.CommunityName + ' and/or any user groups that you manage. \
                You can invite people by email address, or if they are already a member, by name.';
            userAria = 'Names or email addresses of people to invite';
            userPlaceholder = 'Names or email addresses';
        }

        if (dn.constants.TokenInvitationAwardAmount > 0)
        {
            // We are offering a reward in tokens for invitees that start a paid subscription.
            award = '<br/><br/><i class="fas fa-gift mr-1"></i><b>Reward:</b> We\'ll send you <b>' + dn.constants.TokenCurrencySymbolHtml + dn.DecimalToString(dn.constants.TokenInvitationAwardAmount, 2) + '</b> for each new member that starts a paid subscription. <a href="/help#tokens" target="' + dn.constants.LinkTargetNewWindow + '">Learn more about tokens.</a>';
        }

        dn.ShowModal
        ({
            title: 'Invite' + (dn.user.IsGroupManager ? '' : ' to ' + dn.constants.CommunityName),
            body: '<div class="mb-3">' + intro + ' We will not use these email addresses for any other purpose.' + award + '</div>\
                <div><label for="dn-user-search-invite" class="dn-form-label mb-0">People to Invite</label>\
                    <div class="input-group mb-2">\
                        <input name="nameNotSearch" type="text" id="dn-user-search-invite" class="dn-user-search-invite form-control col-12" aria-label="' + userAria + '" placeholder="' + userPlaceholder + '" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" class="form-control dn-compose-users dn-autosuggest-field" data-role="tagsinput"> \
                    </div>' +
                    (dn.user.IsGroupManager 
                        ? '<label for="dn-group-search" class="dn-form-label mb-0">Invite to Groups</label>\
                            <div class="input-group mb-2">\
                                <input name="nameNotSearch" type="text" id="dn-group-search" class="dn-group-search form-control col-12" aria-label="Groups you manage" placeholder="(Optional) Groups you manage" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" class="form-control dn-compose-Topics dn-autosuggest-field" data-role="tagsinput"> \
                            </div>'
                        : ''
                    ) + 
                    '<label for="invite-comments" class="dn-form-label">Comments</label>\
                    <textarea class="form-control" id="invite-comments" class="invite-comments" rows="3" placeholder="(Optional) Let them know why you are inviting them.">' + (opt.message || '') + '</textarea>\
                </div>',
            buttonText: 'Invite',
            buttonClass: 'btn-success dn-group-invite-button',
            onButtonClick: function(event)
            {
                dn.Spin(true);

                $.postJSON
                (
                    "/api/v1/user/invitation", 
                    {
                        Invitees: dn.text.Split($('#dn-user-search-invite').val(), ","),
                        Groups: dn.text.Split((dn.user.IsGroupManager ? $('#dn-group-search').val() : ''), ","),
                        Message: $('#invite-comments').val()
                    }
                )
                .done(function (results) {

                    dn.Spin(false);

                    var invitationResults = '';

                    $.each(results.Results, function(index, result) 
                    {
                        if (!result.Error)
                        {
                            invitationResults += '<li class="text-success"><i class="fas fa-check fa-fw"></i> ' + (result.User && result.User.UserKey ? result.User.Name : result.Identifier) + '</li>';
                        }
                        else
                        {
                            invitationResults += '<li class="text-danger"><i class="fas fa-times fa-fw"></i> ' + (result.User && result.User.UserKey ? result.User.Name : result.Identifier) + ': ' + result.Error + '</li>';
                        }
                    });

                    dn.ShowModal({
                        title: 'Invitations Sent',
                        body: 'The following invitations were just attempted:<br/><br/><ul class="list-unstyled">' + invitationResults + '</ul>'
                    });

                    if (opt.onSuccess)
                    {
                        opt.onSuccess(results);
                    }
                })
                .fail(function (xhr, textStatus, errorThrown) 
                {
                    dn.Spin(false);

                    if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                    {
                        // The initial request for the message details failed, tell the user
                        var body = dn.FormatApiError(xhr.responseJSON);
                        dn.ShowModal({ title: "Unexpected Error", body: body });
                    }

                    if (opt.onError)
                    {
                        opt.onError(xhr, textStatus, errorThrown);
                    }
                });
            }
        });

        if (dn.user.IsGroupManager)
        {
            // AUTOSUGGESTIONS for Topics/Groups
            $('#dn-group-search').selectize(
            {
                loadThrottle: dn.constants.WaitForAutosuggest,
                valueField: "TopicId",
                searchField: "Name",
                optgroupField: "Type",
                lockOptgroupOrder: true,
                optgroups: 
                [
                    {value: 0, label: 'Discussion Topics', $order: 1},
                    {value: 1, label: 'Open User Groups', $order: 2},
                    {value: 2, label: 'Closed User Groups', $order: 3},
                    {value: 4, label: 'Private User Groups', $order: 4},
                ],
                // These next two lines pre-fill any existing topics, filtering out any that are groups that
                // this user is not a subscriber of (since they can't post to them anyway).
                options: (opt.initialGroups || []),
                items: opt.groups,
                sortField: 
                [
                    {
                        field: 'SortOrder',
                        direction: 'asc'
                    },
                    {
                        field: 'Name',
                        direction: 'asc'
                    },
                    {
                        field: '$score'
                    }
                ],
                persist: true,
                hideSelected: true,
                selectOnTab: true,
                create: false,
                plugins: ['remove_button', 'restore_on_backspace'],
                mode: 'multi',
                highlight: false,
                maxItems: 10,
                openOnFocus: true,
                closeAfterSelect: false,
                preload: true,
                onItemAdd: function (identifier, element) 
                {
                    checkEnableInviteButton();
                },
                onItemRemove: function (identifier) 
                {
                    checkEnableInviteButton();
                },
                load: function (query, callback) 
                {
                    dn.topic.Query
                    (
                        {
                            query: query, 
                            isManager: true, 
                            onSuccess: function (data) 
                            {
                                callback(data);
                            }, 
                            onError: function (error) 
                            {
                                callback();
                            }
                        }
                    );
                },
                render: 
                {
                    optgroup_header: function(data, escape) 
                    {
                        return '<div class="topic-optgroup-header">' + escape(data.label) + '</div>';
                    },
                    option: function (data, escape) 
                    {
                        return '<div class="dn-metadata-choice topic-type-' + data.Type + '"><span class="topic-name">' + escape(data.Name) + '</span></div>';
                    },
                    item: function (data, escape) 
                    {
                        return '<div class="dn-topic" style="background-color: ' + data.ColorPrimary + '; color: ' + data.ColorText + '"><i class="' + dn.topic.GetIconClass(data.Type) + '" title="' + dn.constants.TopicTypeNames[data.Type] + '"></i> <span class="topic-name" ' + ((data.Description != null && data.Description != 'null') ? 'data-toggle="popover" title="" data-trigger="hover" data-placement="bottom" data-content="' + escape(data.Description) : '') + '">' + escape(data.NameShort) + '</span></div>';
                    }
                }
            })[0].selectize;
        }

        // setup autosuggest for users
        dn.autosuggest.UserSetup
        (
            {
                selector: '#dn-user-search-invite',
                prefilledUsers: opt.prefilledUsers,
                suggestExisting: dn.user.IsGroupManager, // only bother searching for existing users if they're inviting to groups
                suggestedUsers: opt.suggestedUsers,
                onChange: checkEnableInviteButton
            }
        );

        checkEnableInviteButton();
    };



}(window.dn.user = window.dn.user || {}, jQuery));
